module.exports = __webpack_public_path__ + "img/20230130162959604xta.58e5ece3.jpg";